import { useState } from 'react';
import FilePreviewModal from './FilePreviewModal';
import {baseURL} from "../Constant";
import axios from 'axios';
import { useSelector } from "react-redux";
import "./FilePreviewAndSubmit.css";

const FilePreviewAndSubmit = (props) => {
  const [modalOpen, setModalOpen] = useState(false);  
  const [tempFile, setTempFile] = useState("");
  const [tempFileUrl, setTempFileUrl] = useState("");  
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); 
  
  const userID = useSelector((state) => state.model.userID);

  const handleOpen = () => {    
    setModalOpen(true);
  };

  const handleReplace = async (requestType) => {                
    setLoading(true);
    props.setCertificateLoading(true);
    requestType === 'submit' && props.setIsCertificateGenerationClicked(true);                
    try {
        const response = await axios.post(
          `${baseURL}/pptx/replace-text`, 
          {            
            program: props.programNameCertificate,
            category: props.categoryCertificate,
            date: props.programDateCertificate,
            template: props.selectedTemplate,
            signatures: props.selectedSignature,
            logos: props.selectedLogos,
            requestType: requestType,
          }, 
          {
            headers: {
              Authorization: localStorage.getItem("token"),
              "Content-Type": "application/json"
            }
          }
        );        
        const file = response.data.file;                
        const fileUrl = response.data.fileUrl; 
        const azureFileUrl = response.data.azureFileUrl;                                
        if(requestType === 'submit') {
          AddCertificateRequest(file, fileUrl, azureFileUrl);          
        } 
        if(requestType === 'preview') {
          setTempFile(file);
          setTempFileUrl(fileUrl);
        }
        setLoading(false);                                                  
    } catch (err) {                        
        setError(err.response.data.message || err.message);
        setLoading(false);
    }        
  };

  const handlePreview = () => {        
    if(handleValidation()) {
      setError("");
      handleReplace('preview');                
    } else {
      setError("All required fields must be filled in.");
    }    
    handleOpen();
  }

  const AddCertificateRequest = async (originalFile, fileUrl, azureFileUrl) => {
    try {
        const response = await axios.post(`${baseURL}/pptx/addPreApprovedCertificate`, {
            certificationData: {
              category: props.categoryName,
              subCategory: props.mailerParent,
              type: props.mailerChild,
              programname: props.programNameCertificate,
              user: userID                                                    
            },
            fileName: originalFile,
            outputFileUrl: fileUrl,
            azureFileUrl: azureFileUrl
          }, {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );                    
        const outputFileUrl = response.data.outputFileUrl;                        
        props.setPptLink(outputFileUrl);       
        props.setCertificateLoading(false);                                                            
    } catch (err) {                        
        setError(err.response.data.message || err.message);        
    }
  }

  const handleSubmit = () => {
    if(handleValidation()) {
      setError("");      
      handleReplace('submit');      
    } else {
      setError("All required fields must be filled in.");
      handleOpen();
    }        
  }

  const handleValidation = () => {
    if(!props.campaignRadio || !props.programNameCertificate || !props.categoryCertificate || !props.selectedTemplate) {            
      return false;
    } else {
      return true;       
    }    
  }

  return (
    <>
      <div className='file_preview'>
        <button onClick={handlePreview}>          
          Preview
        </button>                           
        {(tempFile  || error || loading) && <FilePreviewModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}        
          fileName={tempFile}
          fileUrl={tempFileUrl}
          error={error}
          loading={loading}
        />}              
      </div>
      <div className='preapproved_submit'>        
        <button onClick={handleSubmit}>          
          Submit
        </button>
      </div>
    </>    
  );
};

export default FilePreviewAndSubmit;